import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Home from "./Home.jsx";
import LoginPage from "./LoginPage.jsx";
import Dashboard from "./Dashboard.jsx";
import LeftMenu from "./components/LeftMenu.jsx";
import Challenges from "./Challenges.jsx";
import Districts from "./Districts.jsx";
import VisitPage from "./VisitPage.jsx";
import CreateChallenge from "./CreateChallenge.jsx";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CreateVisitTask from "./CreateVisitTask.jsx";
import ChallengesPage from "./ChallengesPage.jsx";
import CreateNormalChallenge from "./CreateNormalChallenge.jsx";
import CreateNormalTask from "./CreateNormalTask.jsx";
import { UnpublishedChallenges } from "./UnpublishedChallenges.jsx";
import TaskRelation from "./TaskRelation.jsx";
const App = () => {
  const isAuthenticated = true;

  return (
    <BrowserRouter>
          <ToastContainer />

      <Routes>
        <Route path="/login" element={<LoginPage />} />{" "}
        {/* Renders at /login */}
        <Route path="/" element={<div className="flex w-screen  min-h-screen">
          <LeftMenu />
          <Home />
        </div>} />
        {/* Renders at / */}
        <Route path="/dashboard" element={<div className="flex w-screen  min-h-screen">
          <LeftMenu />
          <Dashboard />
        </div>} />
        {/* Renders at /dashboard */}
        <Route path="/challenges" element={<div className="flex w-screen  min-h-screen">
          <LeftMenu />
          <Challenges />
        </div>} />
        <Route path="/districts" element={<div className="flex w-screen  min-h-screen">
          <LeftMenu />
          <Districts />
        </div>} />
        <Route path="/visit" element={<div className="flex w-screen  min-h-screen">
          <LeftMenu />
          <VisitPage />
        </div>} />
        <Route path="/challenges-menu" element={<div className="flex w-screen  min-h-screen">
          <LeftMenu />
          <ChallengesPage />
        </div>} />
        <Route path="/create-challenge" element={<div className="flex w-screen  min-h-screen">
          <LeftMenu />
          <CreateChallenge />
        </div>} />
        <Route path="/create-visit-task" element={<div className="flex w-screen  min-h-screen">
          <LeftMenu />
          <CreateVisitTask />
        </div>} />
        <Route path="/create-challenges" element={<div className="flex w-screen  min-h-screen">
          <LeftMenu />
          <CreateNormalChallenge />
        </div>} />
        <Route path="/create-tasks" element={<div className="flex w-screen  min-h-screen">
          <LeftMenu />
          <CreateNormalTask />
        </div>} />
        <Route path="/unpublished-challenges" element={<div className="flex w-screen  min-h-screen">
          <LeftMenu />
          <UnpublishedChallenges />
        </div>} />
        <Route path="/view/:id" element={<div className="flex w-screen  min-h-screen">
          <LeftMenu />
          <TaskRelation />
        </div>} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
